import { css } from "@emotion/react";

export const printStyles = css`
  @media print {
    /* Enable background graphics and colors */
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    /* hides header, print btn tooltip and ava trigger */
    header,
    .MuiTooltip-popper,
    .MuiIconButton-root.MuiIconButton-sizeMedium,
    #root > .MuiBox-root > .MuiTypography-root,
    #main-layout [role="alert"] {
      display: none !important;
    }

    /* First row - 2 cards per row */
    #print-content > div:nth-of-type(1),
    #print-content > div:nth-of-type(2) {
      width: 48% !important;
      display: inline-block !important;
      vertical-align: top !important;
      margin-right: 1% !important;
      margin-bottom: 16px !important;
    }

    #print-content > div:nth-of-type(2) {
      margin-right: 0 !important;
    }

    /* Second row - 2 cards per row */
    [data-cy="cloud-costs-section"] > .MuiGrid2-root {
      flex: 0 0 calc(50% - 8px) !important;
      width: auto !important;
      max-width: none !important;
    }

    /* Anomalies list on new page */
    .MuiCard-root:has(.MuiList-root) {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      page-break-before: auto !important;
      margin-top: 32px !important;
    }

    /* Remove fixed heights from card containers */
    .MuiGrid2-root:has([data-cy*="list-card"]) {
      height: auto !important;
      min-height: auto !important;
    }

    /* Remove flex grow/stretch behavior from cards */
    .MuiCard-root {
      height: auto !important;
      min-height: auto !important;
      flex-grow: 0 !important;
    }

    /* Insights list on a new page */
    #print-content > .MuiGrid2-root:nth-last-of-type(-n + 2) {
      break-before: page !important;
      page-break-before: always !important;
    }
  }

  /* landscape mode */
  @media print and (orientation: landscape) {
    /* Force page breaks for list cards in landscape mode */
    [data-cy="cloud-costs-section"] > .MuiGrid2-root:nth-of-type(3) {
      break-before: page !important;
      page-break-before: always !important;
    }

    /* Target list cards that contain MuiList-root - make full width and separate pages in landscape */
    #print-content > .MuiGrid2-root:has(.MuiCard-root .MuiList-root) {
      width: 100% !important;
      max-width: 100% !important;
      flex: 0 0 100% !important;
      page-break-before: always !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
  }
`;
